"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
// @ts-ignore
var styled_components_1 = __importDefault(require("styled-components"));
var plussa_balls_svg_1 = __importDefault(require("../../../../images/kesko/plussa-balls.svg"));
var PlusContainer = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  text-transform: uppercase;\n  color: #ff6b00;\n  text-align: center;\n  width: 200px;\n  font-size: 22px;\n  margin: auto;\n  z-index: 99;\n  position: relative;\n  line-height: 1.2;\n  color: #ff6b00;\n"], ["\n  text-transform: uppercase;\n  color: #ff6b00;\n  text-align: center;\n  width: 200px;\n  font-size: 22px;\n  margin: auto;\n  z-index: 99;\n  position: relative;\n  line-height: 1.2;\n  color: #ff6b00;\n"])));
var PlusCardText = styled_components_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  font-family: 'Skatta Sans Regular';\n"], ["\n  font-family: 'Skatta Sans Regular';\n"])));
var DiscountPercentage = styled_components_1.default.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  font-family: 'Skatta Sans Bold';\n"], ["\n  font-family: 'Skatta Sans Bold';\n"])));
var PlusImage = styled_components_1.default.img(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  width: 100%;\n  margin-top: 3px;\n"], ["\n  width: 100%;\n  margin-top: 3px;\n"])));
var PlussaCard = function (_a) {
    var _b = _a.item, discountType = _b.discountType, discountPercentage = _b.discountPercentage;
    if (discountType === 'plussa' && discountPercentage) {
        return (react_1.default.createElement(PlusContainer, null,
            react_1.default.createElement(PlusCardText, null, "Plussa-kortilla"),
            react_1.default.createElement(DiscountPercentage, null,
                "-",
                discountPercentage,
                "%"),
            react_1.default.createElement(PlusImage, { src: plussa_balls_svg_1.default, alt: 'Plussa-pallot' })));
    }
    return react_1.default.createElement(react_1.Fragment, null);
};
exports.default = PlussaCard;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
//# sourceMappingURL=PlussaCard.js.map